import "../styles/main.css";
import {
  TrendingUp,
  ChevronRight,
  ExpandMore,
  Description,
  Menu,
  ArrowForward,
} from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import { useOktaAuth } from '@okta/okta-react';

const SidebarItem = ({
  icon: Icon,
  label,
  section,
  active,
  onClick,
  hasSubItems = false,
  expanded = false,
  onToggle,
  level = 0,
  collapsed = false,
  isQuickSearch = false,
}) => {
  const fullLabel = section ? `${section} ${label}` : label;

  return (
    <Tooltip title={collapsed ? fullLabel : ""} placement="right" arrow>
      <button
        onClick={onClick}
        className={`sidebar-item ${active ? "active" : ""} ${isQuickSearch ? "quick-search-item" : ""}`}
        style={{
          justifyContent: collapsed ? "center" : "flex-start",
        }}
      >
        <Icon className="sidebar-item-icon" />
        {!collapsed && (
          <>
            <span className="text-sm flex-1 text-left font-normal">{label}</span>
            {hasSubItems && (
              <div className="sidebar-chevron">
                {expanded ? (
                  <ExpandMore sx={{ fontSize: 16 }} />
                ) : (
                  <ChevronRight sx={{ fontSize: 16 }} />
                )}
              </div>
            )}
          </>
        )}
      </button>
    </Tooltip>
  );
};

const SidebarSection = ({ title, children, collapsed }) => (
  <div className="sidebar-section">
    {!collapsed && <div className="sidebar-section-title">{title}</div>}
    {children}
  </div>
);

export default function ModernTrackRecordsSidebar({
  searchType,
  setSearchType,
  collapsed,
  setCollapsed,
}) {
  const { oktaAuth } = useOktaAuth();

  const handleLogOut = async () => {
    await oktaAuth.signOut({
      postLogoutRedirectUri: window.location.origin + '/login'
    });
  };

  return (
    <div
      className={`sidebar ${collapsed ? "collapsed" : ""}`}
      style={{
        width: collapsed ? "0px" : "260px",
        overflow: collapsed ? "hidden" : "visible",
      }}
    >
      {/* iHub Investment Performance Title */}
      {!collapsed && (
        <>
          <div className="sidebar-header">
            <div className="sidebar-title">iHub Investment Performance</div>
          </div>
          <div className="sidebar-divider" />
        </>
      )}

      <div className="flex-1 pb-4">
        <SidebarSection title="ROA / POSITIONS" collapsed={collapsed}>
          <SidebarItem
            icon={Description}
            label="Quick Search"
            section="ROA / Positions"
            active={searchType === "quick"}
            onClick={() => setSearchType("quick")}
            collapsed={collapsed}
            isQuickSearch={true}
          />
          <SidebarItem
            icon={TrendingUp}
            label="Advanced Track Record"
            section="ROA / Positions"
            active={searchType === "advanced"}
            onClick={() => setSearchType("advanced")}
            collapsed={collapsed}
          />
        </SidebarSection>

        <SidebarSection title="CASHFLOWS" collapsed={collapsed}>
          <SidebarItem
            icon={Description}
            label="Quick Search"
            section="Cashflows"
            active={searchType === "cs_quick"}
            onClick={() => setSearchType("cs_quick")}
            collapsed={collapsed}
            isQuickSearch={true}
          />
          <SidebarItem
            icon={TrendingUp}
            label="Advanced Track Record"
            section="Cashflows"
            active={searchType === "cs_advanced"}
            onClick={() => setSearchType("cs_advanced")}
            collapsed={collapsed}
          />
        </SidebarSection>
      </div>

      <div className="sidebar-divider" />

      {/* LOG OUT Button */}
      {!collapsed && (
        <button
          onClick={handleLogOut}
          className="sidebar-logout"
        >
          <span>LOG OUT</span>
          <ArrowForward className="sidebar-logout-icon" />
        </button>
      )}
    </div>
  );
}
